module.exports = __webpack_public_path__ + "static/img/logo.5560563.png";